import { $, el } from './dom.js';

/**
 * Shows a transient message. `type`: 'info' | 'success' | 'error'.
 */
export function toast(message, { type = 'info', timeout = type === 'error' ? 7000 : 4000 } = {}) {
  const container = $('#toasts');
  if (!container) return;
  const node = el('div', {
    class: `toast toast-${type}`,
    text: message,
    attrs: { role: type === 'error' ? 'alert' : 'status' },
  });
  const dismiss = () => {
    node.style.transition = 'opacity .25s';
    node.style.opacity = '0';
    setTimeout(() => node.remove(), 260);
  };
  node.addEventListener('click', dismiss);
  container.append(node);
  setTimeout(dismiss, timeout);
}
